// update mechanism for this section is under consideration

const clientConfigs = {};
const breakPoints = {
  // screens
  xs: 576,
  md: 768,
  lg: 1024,
  xl: 1200,
  xxl: 1600
};
const mobileScreenSize = Number(process.env.REACT_APP_MOBILE_SIZE) || breakPoints.lg;
const screenTypes = ['desktop', 'mobile'];
const positions = ['top', 'right', 'bottom', 'left'];
const inputConfig = {
  type: ['text', 'color', 'number', 'password', 'textarea', 'date', 'time', 'datetime-local'],
  appearance: ['outline', 'minimal', 'light'],
  size: ['small', 'default', 'big'],
  flexibility: ['full-width', 'content-size'],
  itemsDirection: ['start', 'end'],
  cornerRadius: ['full-radius', 'smooth-radius'],
  labelAppearance: ['none', 'title', 'swap']
};
const titleConfig = {
  color: ['base', 'hero']
};
const checkboxRadioSwitcherConfig = {
  size: ['small', 'big'],
  labelPosition: ['right', 'left', 'top', 'bottom'],
  labelAlignment: ['start', 'center', 'end']
};
const tagConfig = {
  appearance: ['simple', 'minimal', 'outline', 'clean', 'light', 'colored'],
  size: ['small', 'medium', 'big'],
  flexibility: ['content-size', 'compact', 'full-width'],
  cornerRadius: ['full-radius', 'smooth-radius']
};
const stepsConfig = {
  size: ['small', 'big'],
  direction: ['horizontal', 'vertical'],
  appearance: ['steps', 'dots'],
  status: ['initial', 'current', 'success', 'fail', 'activated']
};
const popoverConfig = {
  align: ['start', 'end', 'center'],
  position: ['bottom', 'top', 'left', 'right'],
  cornerRadius: ['full-radius', 'smooth-radius'],
  behave: ['toggle', 'open']
};
const popoverV2Config = {
  onOpenClassName: 'has-popover-opened',
  align: ['start', 'end', 'center'],
  position: ['bottom', 'top', 'left', 'right'],
  cornerRadius: ['full-radius', 'smooth-radius'],
  behave: ['toggle', 'open']
};
const uploaderConfig = {
  uploaderAppearance: ['button', 'input', 'cloud', 'box'],
  uploadedItemsAppearance: ['light', 'minimal', 'detailed', 'box'],
  uploadedFilessAppearance: ['light', 'minimal'],
  gridColumnSize: {
    xs: 1,
    md: 2,
    lg: 4,
    xl: 5,
    xxl: 6
  }
};
const moduleTitleConfig = {
  cornerRadius: ['position-radius', 'no-radius', 'full-radius'],
  position: ['top', 'bottom'],
  size: ['small', 'medium', 'big', 'extra-big']
};
const widgetConfig = {
  type: ['default', 'compact', 'minimal', 'colorful'],
  size: ['small', 'medium', 'big'],
  comparisonStatus: ['initial', 'up', 'down']
};
const customScrollbarConfig = {
  size: ['medium', 'small']
};
const noDataConfig = ['data', 'image', 'search'];
const timePickerConfig = {
  appearance: ['multipleInputs', 'singleInput']
};
const optionConfig = {
  color: ['default', 'hero'],
  border: ['none', 'top', 'bottom'],
  sticky: ['none', 'top', 'bottom'],
  titlePosition: {
    start: 'start',
    center: 'center',
    end: 'end'
  }
};
const keyValueConfig = {
  appearance: {
    horizontal: {
      _key: 'horizontal',
      parentItemClassName: 'geneKeyValue--horizontal',
      labelClassName: 'geneKeyValue__label--horizontal',
      valueClassName: 'geneKeyValue__value--horizontal',
      iconClassName: 'geneKeyValue__icon--horizontal'
    },
    vertical: {
      _key: 'vertical',
      parentItemClassName: '',
      itemClassName: ''
    }
  }
};
const advancedSearchConfig = {
  positions: {
    right: 'right',
    left: 'left'
  }
};
const badgeConfig = {
  color: ['danger', 'primary'],
  size: ['default', 'medium', 'big', 'huge']
};

export { clientConfigs as a, badgeConfig as b, checkboxRadioSwitcherConfig as c, moduleTitleConfig as d, popoverConfig as e, tagConfig as f, popoverV2Config as g, timePickerConfig as h, inputConfig as i, advancedSearchConfig as j, keyValueConfig as k, customScrollbarConfig as l, mobileScreenSize as m, noDataConfig as n, optionConfig as o, positions as p, breakPoints as q, stepsConfig as r, screenTypes as s, titleConfig as t, uploaderConfig as u, widgetConfig as w };
